import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bb5e1354"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "form-wrap" }
const _hoisted_3 = { class: "form-block nongfu-field-placeholder-wrap" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-wrap" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "red-star" }, "故障情況补充说明")
], -1))
const _hoisted_5 = { class: "form-wrap" }
const _hoisted_6 = { class: "form-block" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-wrap" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "red-star" }, "故障情况图片")
], -1))
const _hoisted_8 = { class: "upload-wrap" }
const _hoisted_9 = { class: "form-wrap" }
const _hoisted_10 = { class: "form-block" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-wrap" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, "附件(故障视频、飞行日志文件等)")
], -1))
const _hoisted_12 = { class: "upload-wrap" }
const _hoisted_13 = {
  key: 0,
  style: {"color":"rgba(0, 0, 0, 0.22)"}
}
const _hoisted_14 = {
  key: 0,
  class: "log-info van-hairline--top"
}
const _hoisted_15 = { class: "log-time-name" }
const _hoisted_16 = { class: "log-time-range" }
const _hoisted_17 = { class: "footer-button" }
const _hoisted_18 = { class: "fly-log-wrap" }

import { Field, Button } from 'vant'
import { useRoute, useRouter } from 'vue-router'
import { Ref, ref, reactive, computed, onMounted, nextTick } from 'vue'
import { commonErrorHandle } from '@/utils/error-handle'
import { CommonUploaderFileListItem } from '@/types/public'
import { GetDeviceFlyLogsItem } from '@/types/malfunction-repair'
import {
  appealResponsibleWordOrder,
  addOrUpdatePayOrder,
  getPayOrderDetail,
} from '@/apis/malfunction-repair'
import {
  useMalfunctionRepairOrderDetailInfo,
  useMalfunctionRepairStore,
} from '@/compositions/malfunction-repair'
import { clearToast, showConfirmModal, showToastLoading, showToastSuccess } from '@/utils/tools'
import AppHeader from '@/components/Header.vue'
import CellWrap from './components/cell-wrap.vue'
import FlyLogGroup from './components/flylog-group.vue'
import UploadImage from '@/components/upload/UploadImage.vue'
import PopupCommonWrap from '@/components/popup/common-wrap.vue'
import FaultLogItemTag from './components/fault-logitem-tag.vue'
import CommonFooterWrap from '@/components/CommonFooterWrap.vue'
import CommonFooterNextButton from '@/components/CommonFooterNextButton.vue'
import UploadFile, { judgeMp4 } from '@/components/upload/newUploadFIle.vue'
import { getImageUrlByUuid } from '@/apis/service'
import { USER_AFTERSALE_REPAIR_CAMERA_AUTH } from '@/config/constant'


export default /*#__PURE__*/_defineComponent({
  __name: 'duty-result-appeal',
  setup(__props) {

const $router = useRouter()
const $route = useRoute()
const guid = $route.query.guid as string
const isPlant = $route.query.isPlant === 'true'
const isDetail = $route.query.isDetail === 'true'
const workGuid = ref($route.query.workGuid as string)
const showPopup = ref(false)
const sn = ref('')
const activeGuids: Ref<string[]> = ref([])
const { initFlylogs, removeServiceOrderKeepAlive, removeOrderDutyResultItemKeepAlive } =
  useMalfunctionRepairStore()

const form = reactive({
  description: '',
  images: [],
})
const appealImageList: Ref<CommonUploaderFileListItem[]> = ref([])
const annextList: Ref<CommonUploaderFileListItem[]> = ref([])
const flyLogList: Ref<Array<GetDeviceFlyLogsItem>> = ref([])
const { getOrderDetail } = useMalfunctionRepairOrderDetailInfo()
const selectedFlylogList: Ref<Array<GetDeviceFlyLogsItem>> = ref([])
const canSubmit = computed(() => {
  const images = appealImageList.value
  return (
    form.description &&
    images.filter((item) => item.status === 'uploading').length === 0 &&
    images.filter((item) => item.status === 'done').length
  )
})
function imageListChange(data: CommonUploaderFileListItem[]) {
  appealImageList.value = data
    .filter((item) => item.url && item.status === 'done')
    .map((item) => ({ ...item, content: '' }))
}

function annexListChange(data: CommonUploaderFileListItem[]) {
  annextList.value = data
    .filter((item) => item.url && item.status === 'done')
    .map((item) => ({ ...item, content: '' }))
}
async function initPageDetail() {
  try {
    const data = await getOrderDetail(guid)
    sn.value = data.serial_number
    const flyLogData = await initFlylogs(data.serial_number)
    flyLogList.value = flyLogData
  } catch (error) {
    commonErrorHandle(error)
  }
}
function logChangeHandle(guids: string[]) {
  activeGuids.value = guids
}
function confirmSelectLog() {
  selectedFlylogList.value = flyLogList.value
    .filter((item) => activeGuids.value.indexOf(item.guid) !== -1)
    .map((item) => ({ ...item }))
  showPopup.value = false
}
async function checkFlyLog() {
  showPopup.value = true
}
function back() {
  $router.go(-1)
}

let isShowLogSelect = computed(() => {
  return isPlant
})

const isFromPayDuty = computed(() => {
  return $route.query.from === 'payDuty'
})

const title = computed(() => {
  return isFromPayDuty.value ? '申请技术支持' : '定责结果申诉'
})

async function submitHandle() {
  try {
    await showConfirmModal({
      message: isFromPayDuty.value ? '确认是否提交申请？' : '确认是否提交申诉？',
      className: 'repair-dialog',
    })
  } catch (error) {
    console.log('error', error)
    return
  }
  try {
    showToastLoading()
    if (isFromPayDuty.value) {
      const params = {
        guid: workGuid.value,
        description: form.description,
        images: appealImageList.value
          .filter((item) => item.status === 'done')
          .map((item) => item?.response?.guid),
        annex: annextList.value
          .filter((item) => item.status === 'done')
          .map((item) => {
            let nameArr = item?.response?.fileName.split('.')
            return {
              url: item?.response?.guid,
              suffix: nameArr[nameArr.length - 1],
              file_name: item?.response?.fileName,
            }
          }),
        logs: selectedFlylogList.value.map((item) => item.guid),
      }

      console.log('params', params)

      let addOrUpdatePayOrderData = await addOrUpdatePayOrder(params, guid)
      workGuid.value = addOrUpdatePayOrderData.guid
    } else {
      const params = {
        guid,
        description: form.description,
        images: appealImageList.value
          .filter((item) => item.status === 'done')
          .map((item) => item?.response?.guid),
        annex: annextList.value
          .filter((item) => item.status === 'done')
          .map((item) => {
            let nameArr = item?.response?.fileName.split('.')
            return {
              url: item?.response?.guid,
              suffix: nameArr[nameArr.length - 1],
              file_name: item?.response?.fileName,
            }
          }),
        logs: selectedFlylogList.value.map((item) => item.guid),
      }
      await appealResponsibleWordOrder(params)
    }
    showToastSuccess('提交成功')
    removeServiceOrderKeepAlive()
    removeOrderDutyResultItemKeepAlive()
    setTimeout(() => {
      // 技术定责费用单跳转到发票支付页
      if (isFromPayDuty.value) {
        $router.push({
          name: 'malfunction-repair-service-fee-invoice',
          query: {
            guid: workGuid.value,
            sn: sn.value,
            serviceGuid: guid,
          },
        })
      } else {
        $router.go(-1)
      }
    }, 1500)
  } catch (error) {
    commonErrorHandle(error)
  }
}

const uploadImageRef = ref<InstanceType<typeof UploadImage>>()

const getImageByGuid = async (guid: Array<string>) => {
  // let guidImgMap = new Map()
  // guid.forEach(_ => {
  //   guidImgMap.set(_,'')
  // })
  let param = {
    res_uids: guid,
  }
  let result: any = await getImageUrlByUuid(param)
  return result
}

let setFileList: Function

function uploadFileInitHandle(data: { setFileList: Function }) {
  console.log('uploadFileInitHandle', data)
  setFileList = data.setFileList
}

async function initDetailData() {
  try {
    let data = await getPayOrderDetail(workGuid.value)
    form.description = data.description
    let imgList = await getImageByGuid(data.images)
    uploadImageRef.value.setFileList(
      imgList.map((_) => {
        return {
          url: _.url,
          status: 'done',
          isImage: true,
          response: {
            guid: _.uid,
            url: _.url,
          },
        }
      })
    )
    selectedFlylogList.value = flyLogList.value.filter((_) => data.logs.includes(_.guid))

    let fileList = await getImageByGuid(data.annex.map((_) => _.url))
    setFileList(
      fileList.map((_) => {
        return {
          url: _.url,
          status: 'done',
          isVideo: judgeMp4(_.url),
          response: {
            guid: _.uid,
            url: _.url,
          },
        }
      })
    )
  } catch (e) {
    console.log('e', e)
    commonErrorHandle(e)
  }
}

onMounted(async () => {
  if (isDetail) {
    showToastLoading()
    await initPageDetail()
    await initDetailData()
    clearToast()
  } else {
    !isDetail &&
      showToastLoading({
        message: '故障识别中...',
      })
    await initPageDetail()
    clearToast()
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: _unref(title) }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_unref(Field), {
            rows: "3",
            type: "textarea",
            maxlength: "200",
            class: "desc-textarea",
            modelValue: form.description,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.description) = $event)),
            placeholder: "请输入故障情況补充说明"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createVNode(UploadImage, {
              ref_key: "uploadImageRef",
              ref: uploadImageRef,
              onChange: imageListChange,
              defaultList: appealImageList.value,
              disabled: isDetail,
              cameraAuthKey: _unref(USER_AFTERSALE_REPAIR_CAMERA_AUTH)
            }, null, 8, ["defaultList", "cameraAuthKey"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createVNode(UploadFile, {
              maxCount: 3,
              defaultList: annextList.value,
              onChange: annexListChange,
              onInit: uploadFileInitHandle,
              showUpload: !isDetail,
              deletable: !isDetail,
              cameraAuthKey: _unref(USER_AFTERSALE_REPAIR_CAMERA_AUTH)
            }, null, 8, ["defaultList", "showUpload", "deletable", "cameraAuthKey"])
          ])
        ])
      ]),
      (_unref(isShowLogSelect))
        ? (_openBlock(), _createBlock(CellWrap, {
            key: 0,
            label: "事故日志",
            style: {"margin-top":"12px"},
            fillColor: "rgba(0, 0, 0, 0.44)",
            showArrow: !isDetail,
            onClick: checkFlyLog
          }, {
            "cell-right": _withCtx(() => [
              (selectedFlylogList.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, " 请选择事故日志 "))
                : _createCommentVNode("", true)
            ]),
            block: _withCtx(() => [
              (selectedFlylogList.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedFlylogList.value, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.guid
                      }, [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", null, _toDisplayString(item?.name), 1),
                          _createVNode(FaultLogItemTag, {
                            isBoom: item.isBoom
                          }, null, 8, ["isBoom"])
                        ]),
                        _createElementVNode("div", _hoisted_16, "时长" + _toDisplayString(item?.longStr), 1)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["showArrow"]))
        : _createCommentVNode("", true)
    ]),
    (!isDetail)
      ? (_openBlock(), _createBlock(CommonFooterWrap, { key: 0 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_unref(Button), {
                square: "",
                type: "success",
                onClick: back,
                class: "xa-vant-button-cancel cancel-button"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 取消 ")
                ]),
                _: 1
              }),
              _createVNode(_unref(Button), {
                square: "",
                onClick: submitHandle,
                disabled: !_unref(canSubmit),
                type: "success",
                class: "xa-vant-button"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(isFromPayDuty) ? '提交并生成订单' : '提交申诉'), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(PopupCommonWrap, {
      title: "日志选择",
      show: showPopup.value,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((showPopup).value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_18, [
          _createVNode(FlyLogGroup, {
            maxLength: 2,
            limitMaxTips: "最多可选择两个飞行日志",
            list: flyLogList.value,
            multiple: "",
            guids: activeGuids.value,
            onChange: logChangeHandle
          }, null, 8, ["list", "guids"])
        ]),
        _createVNode(CommonFooterNextButton, {
          onClick: confirmSelectLog,
          title: "确认选择"
        })
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})